import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    // width: '85%',
    margin: 'auto',
    height: '100%',
    backgroundColor: 'white',
    padding: '1rem 3rem',
    overflow: 'hidden',
  },
  innerContainer: {},
  containerHeader: {
    padding: '0 0 1rem 0',
  },
  breadcrumbsInactiveText: {
    color: '#a2a2a2',
    fontFamily: 'Rubik',
    fontWeight: '400',
    fontSize: '14px',
  },
  breadcrumbsActiveText: {
    color: '#1D1D1D',
    fontFamily: 'Rubik',
    fontWeight: '400',
    fontSize: '14px',
  },
  breadcrumbsRightArrow: {
    fontSize: '10px',
    marginTop: '4px',
    color: '#a2a2a2',
  },
  headingText: {
    color: '#1d1d1d',
    fontSize: '24px',
    fontFamily: 'Rubik',
    fontWeight: '500',
  },
  subHeadingText: {
    fontFamily: 'Rubik',
    fontWeight: '300',
    color: '#707070',
    fontSize: '16px',
  },
  sectionText: {
    color: '#1d1d1d',
    fontSize: '18px',
    fontFamily: 'Rubik',
    fontWeight: '500',
    marginTop: '0',
  },
  sectionSubText: {
    color: '#1d1d1d',
    fontSize: '16px',
    fontFamily: 'Rubik',
    fontWeight: '500',
    margin: '18px 0',
  },
  sectionSubTextNoWeight: {
    color: '#1d1d1d',
    fontSize: '16px',
    fontFamily: 'Rubik',
    fontWeight: '400',
    margin: '18px 0',
    wordWrap: 'break-word',
  },
  saveButton: {
    fontFamily: 'Rubik',
    fontWeight: '500',
    border: '1px solid #FE4500',
    backgroundColor: '#FE4500',
    color: 'white',
    marginTop: '20px',
    marginLeft: '20px',
    '&:hover': {
      backgroundColor: '#FE4500',
      opacity: '0.8',
    },
  },
  cancelButton: {
    fontFamily: 'Rubik',
    fontWeight: '500',
    border: '1px solid #FE4500',
    backgroundColor: 'white',
    color: '#FE4500',
    marginTop: '20px',
    '&:hover': {
      backgroundColor: 'white',
      opacity: '0.8',
    },
  },
  sectionContainer: {
    padding: '20px 20px 20px 20px',
    border: '1px solid #DFDFDF',
    marginTop: '1rem',
    borderRadius: '2px',
  },
  section: {
    color: '#1d1d1d',
    fontSize: '18px',
    fontFamily: 'Rubik',
    fontWeight: '500',
    paddingTop: '1rem',
  },
  subSection: {
    padding: '0 30px',
    // '&:last-of-type': {
    //   paddingTop: '20px',
    // }
  },
  branchDetailsContainer: {
    // this is NOT working
    // '& .dashedBorderBottomNoPadd:last-of-type':{
    //   borderBottom: '2px solid #dfdfdf'
    // }
  },
  branchDetailsBorderBottom: {
    borderBottom: '2px dashed #dfdfdf',
    '&:last-of-type': {
      borderBottom: '2px solid #dfdfdf',
      marginBottom: '20px',
    },
  },
  dashedBorderBottom: {
    borderBottom: '2px dashed #dfdfdf',
    paddingBottom: '2rem',
  },
  solidBorderBottom: {
    borderBottom: '1px solid #dfdfdf',
    // paddingBottom: '2rem',
  },
  dashedBorderBottomNoPadd: {
    borderBottom: '2px dashed #dfdfdf',
    // paddingBottom: '2rem',
  },
  branchGallery: {
    padding: '20px 20px 20px 20px',
    border: '1px solid #DFDFDF',
    marginTop: '1rem',
    borderRadius: '2px',
  },
  formTextLabel: {
    fontFamily: 'Rubik',
    fontWeight: '400',
    fontSize: '14px',
  },
  inputText: {
    width: '90%',
    color: '#FAF9F9',
    fontSize: '14px',
    fontFamily: 'Rubik',
    fontWeight: '500',
  },
  backgroundGrey: {
    backgroundColor: '#faf9f9',
  },
  tabPanelHeight: {
    height: 'auto',
  },
  inputTextValidationContainer: {
    border: '1px solid #FE0053',
    borderRadius: '4px',
    marginRight: '20px',
    padding: '13px',
  },
  inputTextValidation: {
    color: '#FE0053',
    fontFamily: 'Rubik',
    fontWeight: '400',
    fontSize: '14px',
  },
  formControl: {
    minWidth: '95%',
  },
  formControlSelect: {
    width: 'auto',
  },
  activeButton: {
    border: '1px solid #FE4500',
    backgroundColor: '#FE4500',
    color: 'white',
    marginTop: '20px',
    marginLeft: '20px',
    '&:hover': {
      backgroundColor: '#FE4500',
      opacity: '0.8',
    },
  },
  inactiveButton: {
    fontFamily: 'Rubik',
    fontWeight: '500',
    border: '1px solid #FE4500',
    backgroundColor: 'white',
    color: '#FE4500',
    marginTop: '20px',
    '&:hover': {
      backgroundColor: 'white',
      opacity: '0.8',
    },
  },
  spanadd: {
    marginRight: '8px',
    position: 'relative',
    top: '1px',
  },
  wordsCount: {
    fontFamily: 'Rubik',
    fontWeight: '300',
    color: '#A2A2A2',
    fontSize: '14px',
  },
  singlePhotoUploadContainer: {
    height: '206px',
    background: '#F5F5F5',
    marginTop: '8px',
    border: '1px solid #dfdfdf',
    borderRadius: '2px',
  },
  galleryPhotoUploadContainer: {
    width: '366px',
    height: '366px',
    background: '#F5F5F5',
    // marginTop: '8px',
    border: '1px solid #dfdfdf',
    borderRadius: '2px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '40px',
  },
  galleryItem: {
    width: '366px',
    height: '366px',
    marginBottom: '40px',
    position: 'relative',
  },
  galleryImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  galleryItemIcon: {
    position: 'absolute',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: '#ffffff',
    boxShadow: '0px 3px 6px #00000059',
    top: '20px',
    right: '20px',
    '&:hover': {
      cursor: 'pointer',
      '& $gallerySetAsBanner': {
        display: 'block',
      },
    },
  },
  gallerySetAsBanner: {
    position: 'absolute',
    width: '278px',
    padding: '20px',
    fontSize: '14px',
    fontFamily: 'Rubik',
    color: '#1d1d1d',
    background: '#FFFFFF',
    boxShadow: '0px 3px 6px #00000040',
    borderRadius: '4px',
    top: '50px',
    right: '0',
    display: 'none',
  },
  hover: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  input: {
    // background: 'blue',
    width: 'calc(100% - 48px)',
  },
  inputNone: {
    display: 'none',
  },
  photoDialogTitle: {
    color: '#1D1D1D',
    fontFamily: 'Rubik',
    fontWeight: '500',
    fontSize: '20px',
    marginRight: '195px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'black',
  },
  hrTop: {
    borderTop: '1px solid #DFDFDF',
    maxWidth: '100%',
    marginBottom: '24px',
  },
  cropperContainer: {
    position: 'relative',
    height: '300px',
    width: '100%',
  },
  zoomContainer: {
    border: '1px solid #DFDFDF',
    borderRadius: ' 0px 0px 4px 4px',
    paddingRight: '16px',
    paddingTop: '14px',
  },
  zoom: {
    color: '#1D1D1D',
    fontSize: '16px',
    fontFamily: 'Rubik',
    fontWeight: '500',
    paddingTop: '1px',
  },
  slider: {
    color: '#FE4500',
    height: '10px',
    background: '#FFFFFF',
  },
  hr: {
    borderBottom: '1px solid #DFDFDF',
    maxWidth: '95%',
    marginTop: '24px',
  },
  cancelDialog: {
    border: '1px solid #FE4500',
    backgroundColor: 'white',
    color: '#FE4500',
    marginLeft: '16px',
    marginBottom: '20px',
    '&:hover': {
      backgroundColor: 'white',
      opacity: '0.8',
    },
  },
  save: {
    border: '1px solid #FE4500',
    backgroundColor: '#FE4500',
    color: 'white',
    marginRight: '16px',
    marginBottom: '20px',
    '&:hover': {
      backgroundColor: '#FE4500',
      opacity: '0.8',
    },
  },
  tagsContainer: {
    border: '1.8px solid #D4D4D4',
    backgroundColor: '#FFFFFF',
    color: '#707070',
    padding: '1px',
    '&:hover': {
      backgroundColor: '#FFF6F2',
      border: '1.8px solid #FE4500',
      color: '#FE4500',
      opacity: '0.8',
    },
    width: 'auto',
    minWidth: '15%',
    height: '2rem',
    marginRight: '5px',
  },
  uploadFileHeading: {
    color: '#000000D8',
    fontSize: '12px',
    fontFamily: 'Rubik',
    fontWeight: '500',
    textAlign: 'center',
    margin: 3,
  },
  uploadFileSubHeading: {
    fontFamily: 'Rubik',
    fontWeight: '300',
    color: '#A2A2A2',
    fontSize: '10px',
    textAlign: 'center',
    margin: 3,
  },
  fileUploader: {
    height: '206px',
    background: '#FFFFFF',
    border: '1px solid #DFDFDF',
    borderRadius: '2px',
    marginTop: '20px',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    marginTop: '0.7rem',
    color: theme.palette.text.secondary,
    zoom: '0.8',
    border: '0.6px solid #D4D4D4',
    boxShadow: 'none',
  },
  padding: {
    padding: theme.spacing(2),
  },
  margin: {
    margin: theme.spacing(1),
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  branchTextContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  rootGridList: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    paddingTop: 20,
  },
  gridList: {
    width: 400,
    height: 200,
  },
  addGalaryImagesContainer: {
    height: '89px',
    background: '#F5F5F5',
    border: '1px solid #dfdfdf',
    borderRadius: '2px',
  },
  zoomOnImageGallery: {
    height: '100% !important',
    background: 'rgb(255 255 255 / 10%) !important',
  },
  schoolGalleryImage: {
    padding: '5px',
    '&:hover, &:focus': {
      cursor: 'pointer',
    },
  },
  bigUploadButton: {
    textTransform: 'none',
    border: '1px solid #FE4500',
    backgroundColor: 'white',
    color: '#FE4500',
    fontSize: '14px',
    marginTop: '20px',
    width: '90%',
    paddingTop: '10px',
    paddingBottom: '10px',
    '&:hover': {
      backgroundColor: 'white',
      opacity: '0.8',
    },
  },
  docsContainer: {
    border: '1px solid #DFDFDF',
    marginTop: '15px',
    marginBottom: '6px',
    width: '99%',
    marginLeft: '1px',
    fontSize: '16px',
    fontFamily: 'Rubik',
    fontWeight: '400',
  },

  // View Details Branch Design
  viewDetailsTabs: {
    fontFamily: 'Rubik',
  },
  viewDetailsSectionContainer: {
    marginTop: '2px',
    fontFamily: 'Rubik',
  },

  facilitiesPad: {
    paddingTop: '3%',
  },

  aboutPageAdmissionButton: {
    // marginLeft: '2%',
    // marginRight: '4%',
    padding: '3%',
    // paddingRight: '2%',
    border: '1px solid #FE4500',
    color: '#FE4500',
    width: 'auto',
    height: '50%',
  },
  aboutPageGridHeight: {
    height: '100%',
    marginLeft: '-3%',
  },
  sectionCenter: {
    // marginLeft: '15%',
    border: '1px solid #dfdfdf',
    marginTop: '2%',
    padding: '5%',
  },
  mgmentBorder: {
    padding: '3%',
    marginRight: '2%',
    // marginBottom: '5%',
  },
  mgmentName: {
    fontSize: '18px',
    fontWeight: '500',
  },
  carouselContainer: {
    // marginLeft: '23%',
  },
  checkBoxHolder: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '6%',
  },
  rightPad: {
    paddingRight: '9px',
    fontWeight: '500',
  },
  topMargin: {
    marginTop: '10px',
    border: '1px solid #dfdfdf',
    borderBottom: '1px solid #fff',
    padding: '0px',
    height: 'auto',
  },
  founderMsgContainer: {
    padding: '3%',
    paddingLeft: '4%',
    paddingRight: '4%',
    marginTop: '8px',
    marginBottom: '8px',
  },
  upperColonBox: {
    marginBottom: '-6.5%',
    marginLeft: '4%',
  },
  founderDescription: {
    padding: '3%',
    background: '#FFF6F2',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid #dfdfdf',
    borderTop: '1px solid #fff',
  },
  founderImageContainer: {
    marginLeft: '7%',
  },
  founderImage: {
    height: '80px',
    width: '80px',
    borderRadius: '50%',
  },
  founderNameRoleBox: {
    paddingLeft: '5%',
    display: 'flex',
    flexDirection: 'column',
  },
  founderName: {
    color: '#441514',
    fontSize: '16px',
    fontFamily: 'Rubik',
    fontWeight: '500',
    marginTop: '18px',
  },
  founderRole: {
    color: '#707070',
    fontSize: '14px',
    fontFamily: 'Rubik',
    fontWeight: '500',
    marginTop: '5px',
  },
  lowerColonBox: {
    marginTop: '-4.5%',
    paddingLeft: '88%',
  },
  colonImg: {
    height: '35px',
    width: '35px',
  },
  bannerImage: {
    width: '80%',
    height: '250px',
    objectFit: 'cover',
  },
  unclaimedButton: {
    fontFamily: 'Rubik',
    fontWeight: '500',
    border: '1px solid #B9B9B9',
    backgroundColor: '#B9B9B9',
    color: 'white',
    marginTop: '20px',
    paddingRight: '3px',
    height: '50px',
    '&:hover': {
      backgroundColor: '#B9B9B9',
      opacity: '1',
    },
  },
  verifiedButton: {
    fontFamily: 'Rubik',
    fontWeight: '500',
    border: '1px solid #fe4500',
    backgroundColor: '#fe4500',
    color: 'white',
    marginTop: '20px',
    paddingRight: '3px',
    height: '50px',
    '&:hover': {
      backgroundColor: '#fe4500',
      opacity: '1',
    },
  },
  claimOwner: {
    position: 'absolute',
    marginLeft: '11.5%',
    fontFamily: 'Rubik',
    // fontWeight: '500',
    border: '1px solid #fff',
    backgroundColor: 'white',
    color: '#000',
    boxShadow: '0px 3px 6px #00000040',
    width: '180px',
    height: 'auto',
    textAlign: 'center',
  },

  claimOwnerVerified: {
    position: 'absolute',
    // marginLeft: '11.5%',
    fontFamily: 'Rubik',
    // fontWeight: '500',
    border: '1px solid #fff',
    backgroundColor: 'white',
    color: '#000',
    boxShadow: '0px 3px 6px #00000040',
    width: '180px',
    height: 'auto',
    textAlign: 'center',
  },
  claimOwnerBtn: {
    padding: '0',
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: 'white',
      opacity: '1',
    },
  },
  claimOwnerText: {
    marginTop: '5px',
    marginBottom: '5px',
  },

  backButton: {
    fontFamily: 'Rubik',
    fontWeight: '500',
    border: '1px solid #FE4500',
    backgroundColor: 'white',
    color: '#FE4500',
    height: '50px',
    marginTop: '20px',
    marginLeft: '20px',
    '&:hover': {
      backgroundColor: '#white',
      opacity: '0.8',
    },
  },
}));

export default useStyles;
